<template>
  <div class="apply-header">
    <div class="app-breadcrumb">
      <a-breadcrumb
        :routes="currentRoute"
        separator=">"
        v-if="type == 'breadcrumb'"
      >
        <template #itemRender="{ route }">
          {{ $t('admin.' + route.title) }}
        </template>
      </a-breadcrumb>
      <div v-else class="navigation-panel" @click="$router.back">
        <left-outlined />
        <a-button type="link">{{ $t('admin.Back') }}</a-button>
      </div>
      <div class="page-header">
        <div class="page-title">
          {{
            $t(
              'admin.' + (title || currentRoute[currentRoute.length - 1].title)
            )
          }}
        </div>
        <div class="page-remark"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import { LeftOutlined } from '@ant-design/icons-vue'

  export default {
    name: 'PageHeader',
    components: { LeftOutlined },
    props: {
      title: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'breadcrumb',
      },
    },
    data() {
      return {
        currentRoute: [],
      }
    },
    computed: {
      ...mapGetters({
        applicationPeriod: 'user/applicationPeriod',
        routes: 'routes/routes',
        menus: 'routes/menus',
      }),
    },
    watch: {
      $route: {
        handler({ path, matched }) {
          this.currentRoute = this.$route.matched
            .filter((item) => {
              return item.path != '/master' && item.path != '/master/home'
            })
            .map((item) => {
              return { title: item.meta.title, name: item.name }
            })
          // console.log(this.currentRoute)
        },
        immediate: true,
      },
    },
    methods: {},
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');

  .app-breadcrumb {
    background-color: white;
    padding: 12px 32px 12px 32px;
    font-size: 14px;
    color: #666666;
    .page-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 4px 0;
    }
    .page-remark {
      display: flex;
      align-items: center;
    }
    .page-title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
      font-weight: bold;
    }
  }
  .navigation-panel {
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    .ant-btn,
    .anticon {
      font-size: 14px;
      color: #333333;
    }
  }
</style>
